import { VALIDATORS_TYPE } from "./constants";
import CodiceFiscale from "codice-fiscale-js";
import Iban from "iban";

export const fieldValidator = (input, type) => {
    switch (type) {
        case VALIDATORS_TYPE.phone: {
            if (input.indexOf('+39') === -1) {
                return false;
            } else {
                return "+39" + input.substring(3).replace(/\D+/g, '');
            }
        }
        case VALIDATORS_TYPE.isPhoneValid: {
            const numberLength = input.length;
            const isLengthValid = numberLength <= 15 && numberLength >= 11;
            if (!isLengthValid) return false;
            if (input[3] !== "3") return false;
            return true;
        }
        case VALIDATORS_TYPE.isProvinceValid: {
            return /^\w{2}$/.test(input);
        }
        case VALIDATORS_TYPE.noNumbers: {
            return input.replace(/\d+/g, '');
        }
        case VALIDATORS_TYPE.suffixLength: {
            return input.slice(0, 5);
        }
        case VALIDATORS_TYPE.onlyNumbers: {
            return input.replace(/\D+/g, '');
        }
        case VALIDATORS_TYPE.email: {
            return /^\S+@\S+\.\S+$/.test(input);
        }
        case VALIDATORS_TYPE.iban: {
            return Iban.isValid(input);
        }
        case VALIDATORS_TYPE.pod: {
            return /^IT\d{3}E\w{8}$/.test(input);
        }
        case VALIDATORS_TYPE.pdr: {
            return /^\d{14}$/.test(input);
        }
        case VALIDATORS_TYPE.fiscalCode: {
            let cf = null;
            try {
                cf = new CodiceFiscale(input);
            } catch (error) {
                throw 'invalid';
            }
            const currentDate = new Date();

            if (cf.year < currentDate.getFullYear() - 18) {
                console.log('Year is less, good');
                return 'ok';
            } else if (cf.year === currentDate.getFullYear() - 18) {
                if (cf.month < currentDate.getMonth() + 1) {
                    console.log('Month is less, good');
                    return 'ok';
                } else if (cf.month === currentDate.getMonth() + 1) {
                    if (cf.day <= currentDate.getDate()) {
                        console.log('Day is less, good');
                        return 'ok';
                    } else {
                        console.log('Day is greater, bad');
                        throw 'age';
                    }
                } else {
                    console.log('Month is greater, bad');
                    throw 'age';
                }
            } else {
                console.log('Year is greater, bad');
                throw 'age';
            }
        }
        case VALIDATORS_TYPE.noValidation:
        default: {
            return input;
        }
    }
}